import { UserType } from "interfaces/models/UserType";
import { GlobalState } from "little-state-machine";

export const updateUserTypes = (state: GlobalState, userTypes: UserType[]) => ({
  ...state,
  userTypes
});
